export enum WarningMessage {
  DataLoadingWarning = 'При загрузке данных произошла ошибка, попробуйте перезагрузить страницу позже',
  IncorrectURLWarning = 'Страница не найдена',
  DataEmptySearchingWarning = 'По вашему запросу ничего не найдено',
  NoProductsMatchingThisFilterWarning = 'По данным фильтрам продуктов не найдено.',
  FilterWrongPriceWarning = 'Введите диапазон цен',
  FilterWrongBottomPriceWarning = 'Введите корректную минимальную цену',
  FilterWrongTopPriceWarning = 'Введите корректную максимальную цену',
  LoadingWarning = '...Загрузка',
  EmptyBasketMessage = 'В данный момент корзина пуста',
  OrderError = 'При отправке заказа произошла ошибка, попробуйте повторить позже',
  DataSendingError = 'При отправке данных произошла ошибка, попробуйте еще раз',
  ProductsAmountMoreThanMaximum = 'Мы не продаем больше 99 единиц товара в одни руки',
  ProductsAmountLessThanMinimum = 'Введите допустимое количество товара: от 1 до 99 единиц или удалите товар из корзины',
  PromoCodeDoesNotExist = 'Промокод неверный',
  PromoCodeSendingError = 'Ошибка отправки',
}
